export function recentProductIds(storage, excluded = []) {
  try {
    const ids = JSON.parse(storage.getItem('viewedProducts') || '[]');
    if (!Array.isArray(ids)) return [];
    const blocked = new Set(excluded.map(String));
    return [...new Set(ids.map(String))].filter((id) => /^[1-9]\d*$/.test(id) && !blocked.has(id)).slice(0, 4);
  } catch { return []; }
}

let instanceCount = 0;
const requests = new Map();
function fetchCards(url) {
  if (!requests.has(url)) requests.set(url, fetch(url).then((response) => {
    if (!response.ok) throw new Error('Recent products unavailable');
    return response.text();
  }).catch((error) => { requests.delete(url); throw error; }));
  return requests.get(url);
}

class AromelyEmptyCart extends HTMLElement {
  connectedCallback() {
    this.instanceId = this.instanceId || ++instanceCount;
    this.sequence = (this.sequence || 0) + 1;
    this.key = '';
    this.onOpen = () => this.load();
    this.dialog = this.closest('dialog');
    this.observer = new MutationObserver(this.onOpen);
    if (this.dialog) this.observer.observe(this.dialog, { attributes: true, attributeFilter: ['open'] });
    this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-promo'] });
    this.load();
  }
  disconnectedCallback() { this.sequence++; this.observer?.disconnect(); }
  async load() {
    let excluded = [], ids = [];
    try { excluded = JSON.parse(this.dataset.excludedProducts || '[]'); ids = recentProductIds(localStorage, excluded); } catch {}
    const key = ids.join(',') + ':' + (document.documentElement.dataset.promo || 'off');
    if (this.key === key) return;
    this.key = key;
    const sequence = ++this.sequence;
    const recent = this.querySelector('[data-cart-empty-recent]');
    const products = this.querySelector('[data-cart-empty-products]');
    const paths = this.querySelector('[data-cart-empty-paths]');
    if (!recent || !products || !paths) return;
    recent.hidden = true; paths.hidden = false; products.replaceChildren();
    if (!ids.length) return;
    const url = new URL(this.dataset.searchUrl || '/search', location.origin);
    url.searchParams.set('q', ids.map((id) => 'id:' + id).join(' OR '));
    url.searchParams.set('type', 'product');
    url.searchParams.set('section_id', 'aromely-promo-recent');
    url.searchParams.set('cart_recent_state', document.documentElement.dataset.promo || 'off');
    try {
      const html = await fetchCards(url.href);
      if (!this.isConnected || sequence !== this.sequence) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const row = doc.querySelector('[data-promo-recent-row]');
      if (!row) return;
      const ordered = ids.map((id) => row.querySelector('[data-cart-recent-product="' + id + '"]')).filter(Boolean);
      if (!ordered.length) return;
      row.replaceChildren(...ordered);
      const cartSection = this.closest('[data-section-id]')?.dataset.sectionId;
      row.querySelectorAll('aromely-variant-modal').forEach((modal) => {
        const oldId = modal.id;
        const newId = oldId + '-empty-' + this.instanceId;
        row.querySelectorAll('[id], [name], [on\\:click], [aria-labelledby]').forEach((element) => {
          ['id', 'name', 'on:click', 'aria-labelledby'].forEach((attribute) => {
            const value = element.getAttribute(attribute);
            if (value?.includes(oldId)) element.setAttribute(attribute, value.replaceAll(oldId, newId));
          });
        });
        if (cartSection) modal.dataset.sectionId = cartSection;
      });
      products.replaceChildren(row.cloneNode(true));
      recent.hidden = false; paths.hidden = true;
    } catch { if (sequence === this.sequence) this.key = ''; }
  }
}
if (!customElements.get('aromely-empty-cart')) customElements.define('aromely-empty-cart', AromelyEmptyCart);
